import { Modal as ChakraModal, HStack, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react'
import { Beta } from 'components'

export default function Modal({ title, children, loading = false, isBeta = false, onClose = () => {}, ...props }){

    const onCloseModal = () => loading ? null : onClose()

    return(
    <ChakraModal onClose={onCloseModal} {...props}>
        <ModalOverlay />
        <ModalContent>
            <ModalCloseButton isDisabled={loading} />
            <ModalHeader>
                <HStack>
                    { isBeta && <Beta />}
                    { !!title && <Text fontSize="1rem" children={title} />}
                </HStack>
            </ModalHeader>
            { children }
        </ModalContent>
    </ChakraModal>
    )
}